var CollapseArrowDirection;
(function (CollapseArrowDirection) {
    CollapseArrowDirection["DOWN"] = "down";
    CollapseArrowDirection["LEFT"] = "left";
    CollapseArrowDirection["RIGHT"] = "right";
    CollapseArrowDirection["UP"] = "up";
})(CollapseArrowDirection || (CollapseArrowDirection = {}));
export { CollapseArrowDirection, };
//# sourceMappingURL=collapse-arrow-constants.js.map